import FormInternationalCurrencyField from "./fields/Form/InternationalCurrencyField.vue"
import DetailInternationalCurrencyField from "./fields/Detail/InternationalCurrencyField.vue"
import IndexInternationalCurrencyField from "./fields/Index/InternationalCurrencyField.vue"

const internationalCurrencyFieldSetup = (app) => {

    /**
     * Register Fields
     */
    app.component('form-international-currency-field', FormInternationalCurrencyField)
    app.component('detail-international-currency-field', DetailInternationalCurrencyField)
    app.component('index-international-currency-field', IndexInternationalCurrencyField)

}

export { internationalCurrencyFieldSetup }

